export { default as Button } from './Component';
